module.exports = __webpack_public_path__ + "static/media/404-or-500.5b096738.svg";